define([
	"dojo/_base/declare",
	"underscore",
	"csi/access/crews",
	"csi/def/Rule",
	"csi/heading/String",
	"csi/html",
	"csi/locale",
	"csi/table/_GroupByRefMixin",
	"csi/table/Widget",
	"csi/xml"
], function(declare, _, crews, Rule, StringRen, html, locale, _GroupByRefMixin, TableWidget, xml) {

	var CREATE_ROLES = ["Product Specification Administrator", "TDS - Spec Creator", "TDS - Spec Administrator"];
	var ATTR_GROUP_REFS = "__GroupRefs__";
	var ATTR_MESSAGE = "__GroupMessage__";
	var NAME_SORT_LAST = "~~~~~~~~~~";

	var _NameRenderer = declare(StringRen, {
		/**
		 * Render message for extra selection nodes rather than name
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var node = ctx.getNode();

			if (xml.isClientUrl(node.$URL)) {
				this._toHtmlString(node[ATTR_MESSAGE], refNode);
				return true;
			}

			return this.inherited(arguments);
		},

		/**
		 * Add CSS class for extra selection nodes
		 */
		_getRenderCSS: function(ctx, h) {
			var css = this.inherited(arguments) || "";
			var node = ctx.getNode();

			if (xml.isClientUrl(node.$URL)) {
				css += " " + html.CSS_DISABLED_COLOR;
			}

			return css;
		}
	});

	return declare([TableWidget, _GroupByRefMixin], {
		groupByRefAttr: xml.ATTR_PARENT,

		/** @property {Store} productStore - data store holding product group values */
		productStore: null,

		/**
		 * @override
		 * Remove default selection row if the group contains a non-frozen datasheet or if a datasheet already contains the section
		 */
		onInsertBodyRow(row) {
			this.inherited(arguments);

			const qr = this.getQueryResultByDomNode(row);

			if (!xml.isClientUrl(qr.url)) {
				return;
			}

			const {cacheView, defView: {m_formData}} = this;
			const {parentResult} = qr;
			let bFound;

			const bFrozen = parentResult.childResults.every((childResult) => {
				// track if section exists in any datasheet
				if (m_formData.isAggregatedUrl(childResult.url)) {
					bFound = true;
				}

				// track if all datasheets are frozen (if rev is null, then it is default selection row)
				const rev = cacheView.getNode(childResult.getNode()?.CurrentRevision);
				return !rev || xml.nodeHasFlag(rev, xml.NODE_FLAG_FROZEN);
			});

			if (!bFrozen || bFound) {
				// briefly wait to delete row or else group row while be removed too
				setTimeout(() => {
					this.deleteRow(row);
				}, 0);
			}
		},

		/**
		 * Default group items should not be included in the count
		 */
		onCreateMainQueryLevel: function(ql) {
			ql.bOmitClientNodesFromCount = true;
		},

		/**
		 * Configure query level for group
		 * @param {Level} ql
		 */
		onGroupByRefQueryLevel: function(ql) {
			ql.groupDefaultsStore = this.productStore;

			ql.onDefaultGroupSelectionItem = function(groupStore, groupNode, groupValue, bEmpty, type, cache) {
				var product = cache.getNode(groupValue);
				var bAccess = crews.isInRoles(CREATE_ROLES, product);

				// do not create selection node for group if no access, unless empty
				if (!bAccess && !bEmpty) {
					return null;
				}

				var params = [locale.type(product.$Type).toLowerCase()];
				var message = locale.resource(bAccess ? "SpecificationSectionPushMissingDatasheet" : "SpecificationSectionPushMissingPermission", params);
				var flags = bAccess ? null : xml.NODE_FLAG_NOEDIT;
				var node = cache.createClientNode(null, type, NAME_SORT_LAST, flags);

				if (!bEmpty) {
					xml.nodeAttributeSetValue(node, ATTR_GROUP_REFS, [].concat(groupNode[groupStore.refsProperty]));
				}

				xml.nodeAttributeSetValue(node, ATTR_MESSAGE, message);

				return node;
			};
		},

		/**
		 * Add renderer class for name heading to handle default group rows
		 */
		_resolveView: function() {
			this.inherited(arguments);
			this.defView.findHeading(xml.ATTR_NAME).classRenderer = _NameRenderer;
		}
	});
});